<template lang="pug">
b-row.h-100
  b-col.h-100.pr-0(lg="4")
    b-card.mb-0.h-100(no-body)
      b-card-header.pb-1
        inbox-filters.mb-1
        b-row.align-items-center
          b-col
            b-form-checkbox(:indeterminate="indeterminate", :checked="allChecked", @change="toggleAllSelected", :disabled="!conversations.length")
          b-col(cols="auto")
            b-dropdown(variant="link", size="sm", no-caret, :disabled="!selectedConversations.length")
              template(#button-content)
                inbox-icon.text-secondary.icon-md.hover-primary.pointer(v-b-tooltip="'Cambiar bandeja'")
              b-dropdown-item(v-for="box in boxes", :key="box.value", @click="updateConversations('change_box', box.value)") {{box.text}}
          b-col(cols="auto")
            b-dropdown(variant="link", size="sm", no-caret, :disabled="!selectedConversations.length", :menu-class="['scroll-dropdown', 'scrollable-area', 'overflow-y']",)
              template(#button-content)
                users-icon.text-secondary.icon-md.hover-primary.pointer(v-b-tooltip="'Asignar admins'")
              b-dropdown-text.text-help.text-center(v-if="!admins.length") No hay administradores para mostrar
              b-dropdown-item(v-for="admin in admins", :key="admin.admin_id", @click="updateConversations('assign_admin', admin.admin_id)") {{admin.email}}
          b-col(cols="auto")
            b-dropdown(variant="link", size="sm", no-caret, right, :disabled="!selectedConversations.length", :menu-class="['scroll-dropdown', 'scrollable-area', 'overflow-y']", @hidden="labelsToAssign = []")
              template(#button-content)
                tag-icon.text-secondary.icon-md.hover-primary.pointer(v-b-tooltip="'Etiquetar'")
              b-dropdown-text.text-help.text-center(v-if="!labels.length") No hay etiquetas para mostrar
              b-dropdown-form(v-else)
                b-form-group
                  b-form-checkbox-group(v-model="labelsToAssign", stacked, :options="labels", @change="updateConversations('assign_labels')")
          b-col(cols="auto", v-if="has_whats_official && $can('create', 'whatsapp-user')")
            b-button(v-if="device && $route.params.conversation_id && hasVoip", size="sm", variant="soft-secondary", @click="openDial = !openDial").mr-2
              phone-call-icon.icon-sm
            b-dropdown(size="sm", variant="light", no-caret)
              template(slot="button-content")
                more-vertical-icon.icon-sm
              b-dropdown-item(@click="createUserModal = true")
                v-icon.icon.text-success.mr-2(name="brands/whatsapp" )
                span Nuevo usuario de Whatsapp
      .text-center.m-0(v-if="getShowCallCounting", :style="{ backgroundColor: '#52B366', color: 'white' }")
        span Llamada en curso: {{ callCounter }}
      .d-flex.flex-column.justify-content-center.h-100(v-if="!loadingConversations && !conversations.length")
        EmptyMessage(message="No hay conversaciones disponibles")
      #conversations-rows.overflow-y.scrollable-area.h-100
        chat-row(v-for="(conversation, index) in conversations", :key="index", v-bind="conversation", v-model="selectedConversations", :timezone="timezone")
        .text-center.my-2(v-if="loadingConversations")
          b-spinner(type="grow", variant="primary")
  b-col.h-100.d-none.d-lg-block(lg="8")
    b-card.card-inactive.text-center.h-100.d-flex.flex-column.justify-content-center(no-body, v-if="!$route.params.conversation_id")
      EmptyMessage(message="Selecciona una conversación para ver sus mensajes")
    b-row.justify-content-end
      Dial(v-if="openDial && $route.params.conversation_id", :device="device", :token="token").h-100.index
    b-row(v-if="isSomeoneCalling").zIndex.justify-content-end
      b-card(no-body, text-variant="white").receiveCall.d-flex.justify-content-center.align-items-center
        div.d-flex.align-items-center.mt-3
          div.mb-2
            b-avatar(size="md", :text="'N'", variant="soft-secondary")
          div.ml-3.flex-column.justify-content-start
            span {{ fromNumber || 'Número desconocido' }}
            p.text Llamada entrante
        div.my-3
          b-button(@click="rejectDirectly", :style="{ backgroundColor: '#FF4D4F' }").m-2.buttonStyle
            x-icon(stroke='white', fill='white').icon-sm
          b-button(@click="connect", :style="{ backgroundColor: '#52B366' }").m-2.buttonStyle
            phone-icon(fill="white", stroke="none").icon-sm
    router-view(:key="$route.params.conversation_id", v-if="$breakpoint.lgUp", @putDevice="handleDevice", @putToken="handleToken")
  b-modal(v-model="createUserModal", title="Crear usuario en Whatsapp", ok-only, ok-title='Cancelar', ok-variant="secondary",)
    send-whatsapp-template(user_id="new", @sent="createUserModal = false")
  SideModal(v-model="sideModalCase", size="lg", @input="$router.push({name: 'Chats'}).then(() => {})")
    template(v-if="sideModalCase")
      router-view.full-height(:key="$route.params.conversation_id")
</template>

<script>
import boxes from '../../data/boxes'
import ChatRow from '../../components/ChatRow.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import { debounce } from 'lodash'
import { EventBus } from '@/helpers/eventBus'
import InboxFilters from '../../components/InboxFilters'
import SendWhatsappTemplate from '../../components/SendWhatsappTemplate'
import Dial from '../../components/Dial'
import { Caller } from '../../helpers/caller'

const accountController = createNamespacedHelpers('account')
const conversationController = createNamespacedHelpers('conversation')
const filtersController = createNamespacedHelpers('inbox_filters')
const labelController = createNamespacedHelpers('label')
const platformController = createNamespacedHelpers('platform')
const CONVERSATION = 'Conversation'
const CONVERSATION_UPDATED = 'Conversaciones actualizadas'
const UPDATE_CONVERSATION_ERROR =
  'Ocurrió un error actualizando algunas conversaciones'
const WHATSAPP = 'whatsapp_official'

export default {
  data() {
    return {
      fromNumber: '',
      isSomeoneCalling: false,
      device: null,
      token: '',
      boxes,
      timezone: '',
      timeCounter: '',
      openDial: false,
      loadingConversations: false,
      createUserModal: false,
      sideModalCase: false,
      labelsToAssign: [],
      selectedConversations: [],
      existingConversations: [],
      callCounter: '',
      caller: null,
      call: null,
      totalSeconds: 0,
      number: ''
    }
  },
  computed: {
    ...filtersController.mapState({
      search_text: (state) => state.search_text,
      user_attribute_id: (state) => state.user_attribute_id,
      dates: (state) => state.dates
    }),
    ...accountController.mapGetters([
      'getFromNumber'
    ]),
    ...filtersController.mapGetters([
      'adminsIds',
      'platformsNames',
      'unreadValue',
      'boxValue',
      'labelsIds',
      'outboundValue',
      'inboundValue',
      'searchIsEnabled',
      'updatedAtEndValue',
      'updatedAtValue'
    ]),
    ...conversationController.mapState({
      conversations: ({ conversations }) => {
        const filters = filtersController.mapGetters(['searchIsEnabled'])

        if (filters.searchIsEnabled) return conversations

        const conversationsIds = conversations.map(({ _id }) => _id)
        const uniqueConversations = new Set(conversationsIds)

        return Array.from(uniqueConversations).map((id) =>
          conversations.find(({ _id }) => _id === id)
        )
      }
    }),
    ...accountController.mapState({
      admins: (state) => state.admins
    }),
    ...labelController.mapState({
      labels: (state) =>
        state.labels.map(({ name: text, label_id: value }) => {
          return { text, value }
        })
    }),
    ...platformController.mapState({
      platforms: (state) => state.platforms
    }),
    ...accountController.mapGetters(['getShowCallCounting']),
    filters() {
      const { updatedAt = null, updatedAtEnd = null } = this.dates

      return {
        admin_ids: this.adminsIds,
        platform: this.platformsNames.length ? this.platformsNames : 'all',
        read: this.unreadValue ? 0 : undefined,
        outbound: this.outboundValue ? 1 : this.inboundValue ? 0 : undefined,
        label_ids: this.labelsIds || null,
        box: this.boxValue,
        updatedAt,
        updatedAtEnd
      }
    },
    indeterminate() {
      if (this.selectedConversations.length && this.conversations.length) {
        return this.conversations.length > this.selectedConversations.length
      }

      return false
    },
    allChecked() {
      if (this.selectedConversations.length && this.conversations.length) {
        return this.conversations.length === this.selectedConversations.length
      }

      return false
    },
    has_whats_official() {
      return this.platforms.find(({ name }) => name === WHATSAPP)
    },
    hasVoip() {
      return this.platforms.find(({ name }) => name === 'voip')
    }
  },
  methods: {
    ...mapActions([
      'account/get',
      'platform/all',
      'conversation/all',
      'conversation/getByMessages',
      'conversation/update',
      'inbox/user',
      'inbox/search',
      'label/all',
      'admin/get',
      'account/getCaseIdFromCall',
      'conversation/get'
    ]),
    handleDevice(device) {
      this.device = device
    },
    handleToken(token) {
      this.token = token
    },
    padNumber(value) {
      return value.toString().padStart(2, '0')
    },
    stopCounter() {
      EventBus.$emit('pleaseStopCounter')
    },
    startCounter() {
      EventBus.$emit('pleaseStartCounter')
    },
    async connect() {
      if (!this.call) return

      this.isSomeoneCalling = false

      await this.getCaseIdFromCall()
      this.call.accept()
    },
    rejectDirectly() {
      if (!this.call) return

      this.isSomeoneCalling = false

      this.call.accept()
      this.call.disconnect()
    },
    async getCaseIdFromCall() {
      const self = this

      this['account/getCaseIdFromCall']({
        account_id: self.$route.params.account_id,
        call_id: self.call.parameters.CallSid,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)

          this.case_id = res.resource.caseId

          EventBus.$emit('putCaseId', this.case_id)

          if (this.case_id) {
            this.$router.push({ name: 'Case', params: { case_id: this.case_id } }).catch(() => {})
          }
        }
      })
    },
    getAccount() {
      this['account/get']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          this.timezone = res.resource.timezone || this.$moment.tz.guess()
        }
      })
    },
    getLabels() {
      this['label/all']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          this.parseResponseForPaginationData(res)
        }
      })
    },
    getConversations() {
      this.loadingConversations = true

      this['conversation/all']({
        account_id: this.$route.params.account_id,
        params: { ...this.paginationParams, ...this.filters },
        callback: (res) => {
          this.loadingConversations = false

          if (res.error) return this.$message.error(res.error)

          this.existingConversations = this.conversations

          this.parseResponseForPaginationData(res)
        }
      })
    },
    searchMessages() {
      this.loadingConversations = true
      const { pagination_hasNextPage: hasNextPage, conversations } = this

      if (!hasNextPage && conversations.length > 0) return

      this['inbox/search']({
        accountId: this.$route.params.account_id,
        params: {
          ...this.paginationParams,
          ...this.filters,
          prompt: this.search_text
        },
        callback: (res) => {
          this.loadingConversations = false

          if (!res.success) return this.$message.error('Error buscando mensajes')

          this.parseResponseForPaginationData(res)
        }
      })
    },
    searchConversations() {
      this.loadingConversations = true
      const getByMessages = 'conversation/getByMessages'
      const inboxUser = 'inbox/user'
      const action = this.user_attribute_id < 0 ? getByMessages : inboxUser

      if (this.searchIsEnabled) return this.searchMessages()

      this[action]({
        account_id: this.$route.params.account_id,
        params: {
          ...this.paginationParams,
          ...this.filters,
          name: this.search_text,
          user_attribute_id:
            this.user_attribute_id && this.user_attribute_id !== 0
              ? this.user_attribute_id
              : null
        },
        callback: (res) => {
          this.loadingConversations = false

          if (res.error) return this.$message.error(res.error)

          this.existingConversations = this.conversations

          this.parseResponseForPaginationData(res)
        }
      })
    },
    requestConversations: debounce(
      function () {
        this.selectedConversations = []

        this.resetPagination()

        this.search_text ? this.searchConversations() : this.getConversations()

        if (this.$route.name === 'Conversation') {
          this.$router.push({ name: 'Chats' }).catch(() => {})
        }
      }, 500, { trailing: true, leading: false }
    ),
    delayRequestConversations: debounce(
      function () {
        this.requestConversations()
      }, 1000, { trailing: true, leading: false }
    ),
    toggleAllSelected(checked) {
      this.selectedConversations =
        checked && this.conversations ? this.conversations.slice() : []
    },
    updateConversations(action, value) {
      if (this.boxValue === value) return

      let errorsCount = 0

      for (let index = 0; index < this.selectedConversations.length; index++) {
        const conversation = this.selectedConversations[index]

        switch (action) {
          case 'change_box':
            conversation.box = value
            break
          case 'assign_admin':
            conversation.admin_ids = [value]
            break
          case 'assign_labels':
            conversation.label_ids = this.labelsToAssign
              ? this.labelsToAssign.slice()
              : []
            break
        }

        this['conversation/update']({
          conversation_id: conversation._id,
          ...conversation,
          callback: (res) => {
            if (res.error) return errorsCount++
          }
        })
      }

      if (errorsCount > 0) return this.$message.error(UPDATE_CONVERSATION_ERROR)

      this.$message.success(CONVERSATION_UPDATED)
    },
    getAccountPlatforms() {
      const self = this

      this['platform/all']({
        account_id: self.$route.params.account_id,
        callback: async (res) => {
          if (res.error) return self.$message.error(res.error)

          if(!this.hasVoip) return

          this.adminEmail = self.getCurrentUser().email
          this.token = await this.generateAccessToken(this.adminEmail)

          if (this.$route.path.includes('chats')) {
            await this.caller.createAndRegisterDevice(this.token)
          }

          EventBus.$emit('putCaller', this.caller)
        }
      })
    },
    async generateAccessToken(name = '') {
      const params = { name }
      this.caller = new Caller(this)
      const token = await this.caller.getToken(params)

      EventBus.$emit('putToken', token)

      return token
    },
    getConversation() {
      const self = this

      if (!self.$route.params.conversation_id) return

      this['conversation/get']({
        conversation_id: self.$route.params.conversation_id,
        callback: res => {
          if (res.error) return self.$message.error(res.error)

          const index = this.existingConversations.findIndex(({ user_id }) => user_id === res.resource.user_id)

          if (index >= 0) this.existingConversations.splice(index, 1, res.resource)
        }
      })
    }
  },
  mounted() {
    const self = this
    this.getLabels()
    this.getAccount()
    this.getAccountPlatforms()

    $('#conversations-rows').on('scroll', function () {
      if (!self.pagination_hasNextPage || self.loadingConversations) return

      const top = $(this).scrollTop()
      const loadMessages = top + this.clientHeight >= this.scrollHeight - 5

      if (!loadMessages) return

      const messagesMethod = self.search_text
        ? self.searchConversations
        : self.getConversations

      messagesMethod()
    })

    EventBus.$on('conversationId', ({ _id, bot_enabled: botEnabled }) => {
      this.$store.commit('conversation/updateConversationData', {
        _id, key: 'bot_enabled', value: botEnabled
      })
    })
    EventBus.$on('putOpenDial', (value) => { this.openDial = value })
    EventBus.$on('putCallCounter', (value) => { this.callCounter = value })
    EventBus.$on('putFromNumber', (value) => { this.fromNumber = value })
    EventBus.$on('getCurrentConversation', () => { this.getConversation() })

    this.getConversations()
  },
  unmounted() {
    EventBus.$off('conversationId')
  },
  watch: {
    call() {
      EventBus.$emit('putCall', this.call)
    },
    filters: {
      deep: true,
      handler: function () {
        if (!this.loadingConversations) return this.requestConversations()
      }
    },
    search_text() {
      this.delayRequestConversations()
    },
    user_attribute_id(value) {
      if (value !== 0) {
        if (this.search_text.length) return this.requestConversations()

        return this.$message.warning('Ingresa un valor para búsqueda por variable.')
      }

      return this.requestConversations()
    },
    conversations(value) {
      if (this.filters.read === 0 && value.length) {
        this.existingConversations = this.conversations

        return this.existingConversations
      }
    },
    $breakpoint(value) {
      if (value.lgUp) this.sideModalCase = false

      if (
        value.mdDown &&
        this.$route.name === CONVERSATION &&
        this.$route.params.conversation_id
      ) {
        this.sideModalCase = true
      }
    },
    $route(value) {
      this.sideModalCase =
        value.name === CONVERSATION &&
        value.params.conversation_id &&
        this.$breakpoint.mdDown
    }
  },
  components: {
    InboxFilters,
    ChatRow,
    SendWhatsappTemplate,
    Dial
  }
}
</script>

<style lang="scss" scoped>
.index {
  z-index: 999;
  position: absolute;
  margin-right: 30px;
  top: 100px;
}
.receiveCall {
  z-index: 999;
  width: 250px;
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 15px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
  background-color: rgba(48, 49, 53, 0.95);
}

.zIndex {
  z-index: 999;
  position: absolute;
  top: 80px;
  right: 20px;
}

.buttonStyle {
  border-radius: 200px;
  height: 40px;
  width: 40px;
  border: none;
}
</style>
